<template>
  <div>
    <div>{{ target.title }}</div>
    <div>ID: {{ targetId }}</div>
    <b-form-input
      id="input-document-and-other"
      type="text"
      placeholder="Enter Title"
      v-model="title"
      :readonly="!editing"
    />
    <b-form-input
      id="input-document-and-other"
      type="text"
      placeholder="Enter target artifact url"
      v-model="link"
      :readonly="!editing"
    />

    <div v-if="editing">
      <b-button @click="cancelEditDetails">Cancel</b-button>
      <b-button @click="saveTarget">Save Target Description</b-button>
      <b-button variant="danger" @click="deleteTarget">Delete Target</b-button>
    </div>
    <div v-else>
      <b-button @click="editDetails">Edit</b-button>
    </div>
    <br />
  </div>
</template>
<script>
export default {
  name: "EditProjectOneTarget",
  data() {
    return {
      title: this.target.title,
      link: this.target.link,
      editing: false,
    };
  },
  props: ["targetId", "projectId", "target"],
  methods: {
    editDetails() {
      this.editing = true;
    },
    cancelEditDetails() {
      this.editing = false;
      this.title = this.target.title;
      this.link = this.target.link;
    },
    deleteTarget() {
      console.log(
        `Button pressed to Delete targetId ${this.targetId} project ${this.projectId}`
      );
    },
    saveTarget() {
      console.log(
        `Button pressed to Update targetId ${this.targetId} project ${this.projectId} with ${this.title} ${this.link}`
      );
    },
  },
};
</script>
<style scoped></style>
